import React, { useState, useEffect } from "react";
import useSalesReceiptStore from "../store";

export default function TenderTypes() {
  const { tenderTypes, setTenderTypes } = useSalesReceiptStore();
  const initialTenderType = { tender_type: "", amount: 0 };
  const [newTenderType, setNewTenderType] = useState(initialTenderType);
  const [editIndex, setEditIndex] = useState(-1);
  const [totalTenderTypes, setTotalTenderTypes] = useState(0);

  useEffect(() => {
    const sum = tenderTypes.reduce((acc, item) => acc + parseFloat(item.amount), 0);
    setTotalTenderTypes(sum);
  }, [tenderTypes]);

  const handleTenderTypeChange = (e, index) => {
    const updatedTenderTypes = [...tenderTypes];
    updatedTenderTypes[index].tender_type = e.target.value;
    setTenderTypes(updatedTenderTypes);
  };

  const handleAmountChange = (e, index) => {
    const updatedTenderTypes = [...tenderTypes];
    updatedTenderTypes[index].amount = parseFloat(e.target.value);
    setTenderTypes(updatedTenderTypes);
  };

  const handleAddTenderType = () => {
    if (editIndex === -1) {
      setTenderTypes([...tenderTypes, newTenderType]);
    } else {
      const updatedTenderTypes = [...tenderTypes];
      updatedTenderTypes[editIndex] = newTenderType;
      setTenderTypes(updatedTenderTypes);
      setEditIndex(-1);
    }
    setNewTenderType(initialTenderType);
  };

  const handleDeleteTenderType = (index) => {
    const updatedTenderTypes = [...tenderTypes];
    updatedTenderTypes.splice(index, 1);
    setTenderTypes(updatedTenderTypes);
  };

  // if (tenderTypes.length === 0) {
  //   return null
  // }

  return (
    <div className="mx-3 my-3 border-white rounded shadow-sm p-3">
      <h4>Other Tender Types</h4>
      <div className="my-2"
       style={{
        minHeight: "87px",
      }}
      >
        {tenderTypes.map((item, index) => (
          <div key={index} className="d-flex  mb-3">
            <label className="mx-1 w-100 form-control">{item.tender_name}</label>
            <input
              type="number"
              min={0}
              className="form-control"
              name="amount"
              value={item.amount}
              onChange={(e) => handleAmountChange(e, index)}
              readOnly
              disabled
            />
           
          </div>
        ))}
      </div>
      <hr className="featurette-divider" />
      <div className="row d-flex justify-content-end align-items-center mt-3">
        <div className="col-md-6 d-flex">
          <h5 className="text-muted">Total Tender Types:</h5>
          <p className="fw-bold fs-5">${totalTenderTypes.toFixed(2)}</p>
        </div>
      </div>
      <hr className="featurette-divider" />
    </div>
  );
}
